import { TimelineComponent } from './timeline/timeline.component';
import { ComponentRegistry } from '../core/component-registry';
var TimelineModule = /** @class */ (function () {
    function TimelineModule() {
        ComponentRegistry.register('route', 'TimelineComponent', TimelineComponent);
    }
    return TimelineModule;
}());
export { TimelineModule };
